import { MessageCircle } from "lucide-react";

import { EmptyState } from "@/components/ui/empty-state";

/**
 * `ChatPage`'s right-pane content at the bare `/chat` index route — desktop
 * only in practice, since mobile hides this pane entirely until a
 * conversation is selected (see ChatPage.tsx). Never rendered once
 * `/chat/:conversationId` matches; `ChatConversationPage` takes over then.
 */
export function ChatEmptyDetailPage() {
  return (
    <div className="flex h-full items-center justify-center p-6">
      <EmptyState
        icon={MessageCircle}
        heading="Select a conversation"
        description="Choose a message from the list to view it here."
      />
    </div>
  );
}
